import scriptjs from 'scriptjs';
import {autobind} from 'core-decorators';
import {getDOMNode, getDOMNodes} from 'utils';
import BaseAdapter from './base';

export const loadScript = scriptjs;

@autobind
export default class MediasiteAdapter extends BaseAdapter {
    static findVideos() {
        const re = /mediasite.+?\/Play\/([\w-]+)/;
        const nodes = getDOMNodes('iframe').filter(iframe => iframe.src.match(re));
        return nodes.map(iframe => ({
            provider: 'mediasite',
            videoURL: iframe.src,
            videoId: iframe.src.match(re)[1],
            videoNode: iframe,
        }));
    }

    initialize(options) {
        this.videoURL = options.videoURL;
        return super.initialize(options);
    }

    loadAPI() {
        return new Promise((resolve, reject) => {
            // Automatic loading of player's API
            const apiURL = '//dev-vwrap.cielo24.com/sdks/mediasite-iframe-api.js';
            const check = () => {
                if (window.Mediasite) resolve();
                else setTimeout(check, BaseAdapter.CHECK_INTERVAL);
            };

            if (!getDOMNode(`script[src="${apiURL}"]`)) exports.loadScript(apiURL, check);
            else check();

            const timeout = () => reject('Mediasite API failed to load');
            setTimeout(timeout, BaseAdapter.API_TIMEOUT);
        });
    }

    attach() {
        return new Promise((resolve, reject) => {
            this.api = new window.Mediasite.Player(this.videoNode.getAttribute('id'), {
                url: this.videoURL,
            });
            this.api.addHandler('currenttimechanged', this.syncPlayhead);
            this.api.addHandler('playstatechanged', this.handleStateChange);
            this.api.addHandler('error', () => reject('Kaltura Player initialization failed'));
            this.api.addHandler('ready', this.handleReady);
            this.api.addHandler('ready', () => resolve());
        });
    }

    handleReady() {
        this.setDuration(this.getDuration());
    }

    handleStateChange(data) {
        const state = data.playState;

        this.isPlaying = state === 'playing';
        if (this.isPlaying) this.seeking = false;

        const stateNames = {
            buffering: BaseAdapter.STATES.Buffering,
            paused: BaseAdapter.STATES.Paused,
            playing: BaseAdapter.STATES.Playing,
        };

        if (stateNames[state]) this.setPlayerState(stateNames[state]);
    }

    syncPlayhead(data) {
        if (!this.seeking) this.setPlayhead(this.toMS(data.currentTime));
    }

    seek(time) {
        this.seeking = true;
        this.api.seekTo(this.toSS(time));
    }

    pause() {
        this.api.pause();
    }

    getDuration() {
        return this.toMS(this.api.getDuration());
    }

    getCurrentTime() {
        return this.toMS(this.api.getCurrentTime());
    }

    getVideoTitle() {
        return new Promise(resolve => resolve(''));
    }
}



// WEBPACK FOOTER //
// ./scripts/adapters/mediasite.js